<template>
  <section>
    <b-container fluid class="mt-4">
      <b-row align-v="start" class="section-title">
        <b-col cols="12" lg="10" offset-lg="1" xl="8" offset-xl="2">
          <h2>Discutez avec les utilisateurs connectés sur le Chat !</h2>
        </b-col>
      </b-row>
      <b-row class="section-content">
        <b-col cols="12" lg="3">
          <ChatUsers/>
        </b-col>
        <b-col cols="12" lg="9">
          <ChatBox/>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
import ChatUsers from "./ChatUsers";
import ChatBox from "./ChatBox";

export default {
  name: "Chat",
  components: {
    ChatUsers,
    ChatBox
  }
};
</script>
